<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 設問情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>設問情報の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/question.png" width="100%">
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 追加ボタン
      </div>
      <div class="manual-explain">
        クリックすることで追加画面が表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 並替ボタン
      </div>
      <div class="manual-explain">
        クリックすることで並替画面が表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 削除ボタン
      </div>
      <div class="manual-explain">
        クリックすることで選択した情報を削除します。<br>
        ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> Filter
      </div>
      <div class="manual-explain">
        設問一覧に表示されているデータのフィルタリングを行います。<br>
        ※フィルタリングの対象は、ID、設問、設問タイプ
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> 設問一覧
      </div>
      <div class="manual-explain">
        登録済みの設問情報の一覧が表示されます。<br>
        編集アイコンをクリックすることで編集画面が表示されます。
      </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Question Information
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Question Information</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_question.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the add screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Sort Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the sort screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button will delete the selected information.<br>
          The button is enabled by checking the delete checkbox in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the question list.<br>
          *Filter targets: ID, Question, Question Type
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Question List
        </div>
        <div class="manual-explain">
          Displays a list of registered question information.<br>
          Clicking the edit icon will display the edit screen.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>
  
</div>